export default __webpack_public_path__ + "static/media/DJI_0895.MP4.00_00_54_19.Still007.c8e3df3c.jpg";